import {createSelector} from 'reselect';

import {AuthenticationState} from '@common/types/stores/authenticationStore.types';

const createPreferenceSelector = createSelector.withTypes<AuthenticationState>();

export const selectUser = createPreferenceSelector([state => state], state => state.user);
